import { Badge, Box, Group, Paper, Text } from "@mantine/core";
import { IconCalendar, IconFile, IconUsersGroup } from "@tabler/icons-react";
import type { GroupTrainerOutput } from "@/api-types";
import { UniversalRoutes, useNavigator } from "@/routers/routes";
import { getGroupStatusColor, getGroupStatusDisplayText } from "@/utils/groups";

export const GroupCard = ({ group }: { group: GroupTrainerOutput }) => {
  const { navigator } = useNavigator();

  return (
    <Paper
      p="md"
      withBorder
      bg="third.1"
      style={{ cursor: "pointer" }}
      onClick={navigator({
        path: UniversalRoutes.GROUPS.DETAIL,
        params: { groupId: group.id },
      })}
    >
      <Box>
        <Group justify="space-between" align="center" mb="xs">
          <Text fw="bold" size="lg">
            {group.name}
          </Text>
          <Group>
            <Badge
              color={group.groupClassType ? "green" : "red"}
              variant="light"
            >
              {group.groupClassType ? "Bookable" : "Not Bookable"}
            </Badge>
            <Badge color={getGroupStatusColor(group.status)} variant="light">
              {getGroupStatusDisplayText(group.status)}
            </Badge>
          </Group>
        </Group>

        {group.description && (
          <Text size="sm" c="dimmed" mb="sm" lineClamp={2}>
            {group.description}
          </Text>
        )}

        <Group gap="md">
          <Group gap="xs">
            <IconUsersGroup size={16} color="gray" />
            <Text size="sm" c="dimmed">
              {group.participantCount} / {group.maxParticipants}
            </Text>
          </Group>

          <Group gap="xs">
            <IconFile size={16} color="gray" />
            <Text size="sm" c="dimmed">
              {group.files.length} files
            </Text>
          </Group>

          <Group gap="xs">
            <IconCalendar size={16} color="gray" />
            <Text size="sm" c="dimmed">
              {group.groupClassType
                ? `${group.sessions.length} sessions`
                : "No class type"}
            </Text>
          </Group>
        </Group>
      </Box>
    </Paper>
  );
};
